import { createContext, useContext } from 'react';

import { __DEV__ } from '@toolbox/utils';

import type { ProviderProps } from 'react';

export type RadioGroupContextValue<V = unknown> = {
  name: string;
  onChange: (value: V) => void;
  value: V;
};
export const RadioGroupContext = createContext<RadioGroupContextValue | undefined>(undefined);

if (__DEV__) {
  RadioGroupContext.displayName = 'RadioGroupContext';
}

export function useRadioGroupContext<V>(): RadioGroupContextValue<V> | undefined {
  return useContext(RadioGroupContext) as RadioGroupContextValue<V> | undefined;
}

export function RadioGroupContextProvider<V>(props: ProviderProps<RadioGroupContextValue<V>>) {
  return <RadioGroupContext.Provider {...(props as Record<string, any> as any)} />;
}
